<template>
    <div>
        <div>
            <!-- 导航栏 -->
            <el-menu :default-active="activeIndex" class="el-menu-demo" style="background:#f2f2f2;display:flex;justify-content:center;align-items:center;" mode="horizontal" @select="handleSelect">
                <div style="margin-right:10px;font-size:13px;color:#999;">欢迎来到听说科技</div>
                <div style="margin:0 30px 0 10px;font-size:13px;color:#999;">欢迎您：{{this.userName}}</div>
                <el-menu-item index="1">
                    <router-link to="/refer">写作练习</router-link>
                </el-menu-item>
                <div>|</div>
                <el-menu-item index="2">
                    <router-link to="/articallist">我的文章</router-link>
                </el-menu-item>
                <div>|</div>
                <el-menu-item index="3">
                    <router-link to="/checkdetail">批改详情</router-link>
                </el-menu-item>
                <div>|</div>
                <el-menu-item index="4">
                    <router-link to="/combo">我的套餐</router-link>
                </el-menu-item>
                <div>|</div>
                <el-menu-item index="5">
                    <router-link to="studentUser">用户中心</router-link>
                </el-menu-item>
                <div>|</div>
                <el-menu-item index="6">
                    <router-link to="studentShoppingCar">我的购物车</router-link>
                </el-menu-item>
                <div>|</div>
                <el-menu-item index="7">
                    <router-link to="/studentIndex">主页</router-link>
                </el-menu-item>
                <el-menu-item index="8">
                    <router-link to="/login">退出</router-link>
                </el-menu-item>
            </el-menu>
            <!-- 表格 + 分页 -->
            <div style="width:60%;margin:20px auto;">
                <!-- 表格 -->
                <el-table
                    :data="tableData.slice((this.currentPage-1)*this.pageSize,this.pageSize*this.currentPage)"
                    style="width: 80%;margin:0 auto;"
                    :border=true
                    highlight-current-row
                >
                    <el-table-column
                        type="index"
                        width="50"
                        align='center'>
                    </el-table-column>
                    <el-table-column
                        prop="date"
                        label="日期"
                        width="288"
                        align='center'>
                    </el-table-column>
                    <el-table-column
                        prop="title"
                        label="标题"
                        width="288"
                        align='center'>
                    </el-table-column>
                    <el-table-column
                        prop="state"
                        label="状态"
                        width='287'
                        align='center'>
                    </el-table-column>
                </el-table>
                <!-- 分页 -->
                <el-pagination
                    layout="total,sizes,prev, pager, next,jumper"
                    :total="50"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[5,10,15,20]"
                    :page-size=this.pageSize
                    :current-page=this.currentPage
                    style="margin:20px 0 0 240px;">
                </el-pagination>
            </div>   
        </div>
    </div>
</template>
<script>
    import { home } from '@/api'
    export default {
        data(){
            return{
                activeIndex:'2',
                userName:'张三',
                tableData:[
                    {
                        date:'2020-01-06',
                        title:'我和我的祖国',
                        state:'已批改'
                    },
                    {
                        date:'2020-01-05',
                        title:'被拯救的姜戈',
                        state:'待批改'
                    },
                    {
                        date:'2020-01-08',
                        title:'悄悄是别离的笙箫',
                        state:'已批改'
                    },
                    {
                        date:'2020-01-08',
                        title:'沉默是今晚的康桥',
                        state:'待批改'
                    },
                    {
                        date:'2020-01-01',
                        title:'哪吒之魔童降世',
                        state:'待批改'
                    },
                    {
                        date:'2020-01-01',
                        title:'我眼中的德云社',
                        state:'已批改'
                    },
                    {
                        date:'2020-01-07',
                        title:'临晨四点的洛杉矶',
                        state:'待批改'
                    },
                    {
                        date:'2020-01-08',
                        title:'我不是药神',
                        state:'待批改'
                    },
                ],
                pageSize:5,
                currentPage:1
            }
        },
        mounted(){},
        methods:{
            // 页面初始化的接口
            init(){
                home.getArtical().then( res=>{
                    console.log('成功！')
                    // this.tableData = res.data.data.table  //获取后台数据，渲染表格内容
                }).catch( err=>{
                    console.log(err)
                })
            },
            handleSelect(key,keyPath){
                console.log(key,keyPath)
            },
            handleSizeChange(val){
                this.pageSize = val;
            },
            handleCurrentChange(val){
                this.currentPage = val;
            },
            
        }
    }
</script>
<style scoped>
    a{
        display:inline-block;
        width:100%;height:100%;
        text-decoration: none;
    }
</style>
<style>
    /* .el-table__body tr.current-row>td{
        background-color: #f19944 !important;
    } */
</style>